<template>
  <div id="skillInfo" class="skillInfo-box">
    <audio :src="audio_url" autoplay id="audio"></audio>
    <audio :src="resources_url" autoplay id="resourcesUrl"></audio>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/productList' }">产品列表</el-breadcrumb-item>
      <el-breadcrumb-item :to="'/skillSetting?client_id=' + this.$route.query.client_id" >技能商店</el-breadcrumb-item>
      <el-breadcrumb-item>技能详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="skill_info_top">
      技能详情
    </div>
    <div class="skill_info_bottom">
      <div class="skill_info_left">
        <div class="item-content-top">
          <div class="top-part">
            <img :src="skillInfo.skill_icon_url" alt="">
          </div>
          <div class="top-part" style="margin-right: 30px">
            <div class="top-part-param  detailTitle" >
              <el-tooltip :content="skillInfo.skill_name" placement="top">
               <i style="font-style:normal"> {{skillInfo.skill_name}}</i>
              </el-tooltip>
            </div>
            <div class="top-part-param">{{skillInfo.open_skill_type | openSkillType}}</div>
          </div>
          <!--<el-button type="primary" round size="mini" class="use_btn">添加</el-button>-->
          <el-button type="primary" v-show="skillInfo.invoke_status == '0'" size="mini" round class="use_btn"
                     @click.prevent.stop="invokeSkill(skillInfo)">添加
          </el-button>
          <el-button type="primary" v-show="skillInfo.invoke_status == '1'" size="mini" round class="use_btn"
                     @click.prevent.stop="invokeSkillDelete(skillInfo)">取消添加
          </el-button>
          <!--<a href="javascript:;" class="use_btn">添加</a>-->
          <div class="item-content-bottom">
            <div class="context" style="font-size: 12px">
              <p>来自:{{skillInfo.developer}}</p>
              <p>更新: {{skillInfo.update_time}}</p>
            </div>
            <div class="context">
              {{skillInfo.skill_intro}}
            </div>
            <div class="context">
              <h4>表达示例:</h4>
              <p v-for="item in skillInfo.skill_order_word">{{item}}</p>
            </div>
            <div class="context">
              <h4>支持设备:</h4>
              <p>{{skillInfo.smarthome_support_device ? skillInfo.smarthome_support_device : '暂无支持设备信息'}}</p>
            </div>
            <div class="context">
              <h4>版本说明:</h4>
              <p>{{skillInfo.skill_version_intro ? skillInfo.skill_version_intro : '暂无版本说明'}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="skill_info_right">
        <ul id="chat">
          <li v-for="(item, index) in queries" v-show="item!=='' && item.text != ''" :key="index" :id="item.name == 'user' ? 'user_speak' : 'system_speak'">
            <img :src="item.name == 'user' ? '../../../static/images/test/devIcon.png' : '../../../static/images/test/SysIcon.png'" alt="头像" class="img-rounded">
            <p>
              {{item.text}}
              <i></i>
            </p>
          </li>
        </ul>
        <div class="voice">
          <p style="text-align: center;margin: 0 auto;">
              <span>
                <input type="text" placeholder="说点什么吧" v-model.trim="itemry" @keyup.enter="test"/>
                <button class="btn" @click="test" :disabled="flag">发送</button>
              </span>
            <img :src="mic_change" alt="麦克风" class="Microphone" @mousedown="micDown" @mouseup="micUp" @mouseout="micUp">
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import qs from 'qs'
  import {HZRecorder,mediaStart,mediaStop} from '@/components/skill/intention/work.js'
  import {skillDetailApi, postTest, ttsApi, getUserId} from '@/api'
  import {invokeSkillApi, invokeSkillDeleteApi} from '@/api/hardIndex.js'
  import commonMethods from '@/mixins/commonMethods.js'

  export default {
    mixins: [
      commonMethods
    ],
    data() {
      return {
        skillInfo: {
          avatar: "../../../../static/images/bg.jpg",
          task: "查快递",
          type: "工具-其他",
          des: "用户可以通过语音交互方便查询快递信息查询快递信息查询快递信息"
        },
        queries: [],
        itemry: "",
        flag: false,
        audio_url: '',
        resources_url: '',
        dev_id: '',
          mic_change: '../../../../../static/images/skill/Microphone.png',
          mediaLoading:false,
          micDownFlag: true
      };
    },
    created() {
      this.getSkillDetail()
      this.getUserId()
    },
    methods: {
        micDown () {
            this.micDownFlag = false //判断是否为录音状态
            this.mic_change = '../../../../static/images/skill/Microphone2.png';
            if(mediaStart() == 'no'){
                this.$message.warning('您的设备不支持录音')
//          alert('您的设备不支持录音')
                return false;
            }else{
                mediaStart();
            }
        },
        micUp () {
            if (this.micDownFlag) return
            this.mediaLoading = true
            this.micDownFlag = true
            this.mic_change = '../../../../static/images/skill/Microphone.png';
            var _this = this;
            var arr = mediaStop().slice(44,-1);
            function randomPid(randomFlag, min, max) {
                var str = "",
                    range = min,
                    arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

                // 随机产生
                if (randomFlag) {
                    range = Math.round(Math.random() * (max - min)) + min;
                }
                for (var i = 0; i < range; i++) {
                    var pos = Math.round(Math.random() * (arr.length - 1));
                    str += arr[pos];
                }
                return str;
            }

            // 初始化一个 WebSocket 对象
            var ws = null
            if (window.location.host.includes('opentw.ainirobot.com')) {
                ws = new WebSocket("wss://jp-asrwss.ainirobot.com:443/ws/streaming-asr");
            } else {
                ws = new WebSocket("wss://asrwss.ainirobot.com:443/ws/streaming-asr");
            }

            // 建立 web socket 连接成功触发事件
            ws.onopen = function () {
                //console.log("连接ASR服务器成功");
                //发送数据
                //首包
                var pkgnum = 2;
                var sid = "ws_asr_" + randomPid(false, 32);
                var pid = '7001';
                var app_name = 'com.cm.speech.asr';
                var firstPkg = "{\"sid\":\"" + sid + "\",\"pid\":\"" + pid + "\",\"app\":\"" + app_name + "\",\"devid\":\"test-20171009001\",\"token\":\"\",\"type\":\"0\"}"; //app为微信端新分配，可以再协商
                if (window.location.host.includes('opentw.ainirobot.com')) {
                    //首包
                     sid = "ws_asr_tw_" + randomPid(false, 32);
                     pid = '61';
                     app_name = 'com.cm.speech.asr';
                     firstPkg = "{\"sid\":\"" + sid + "\",\"pid\":\"" + pid + "\",\"app\":\"" + app_name + "\",\"devid\":\"test-20171009001\",\"token\":\"\",\"type\":\"0\"}"; //app为微信端新分配，可以再协商

                }
                //console.log("first-pkg:" + firstPkg);
                ws.send(firstPkg) //发第一个包

                //console.log('ws握手成功，可以开始发送数据流');


                var dataPkg = parseInt(arr.size);

                var len = 1600; //语音包暂定1024，可以根据实际情况修改
                var blocks = parseInt(dataPkg / len);
                var lastPkg = parseInt(dataPkg % len);
                if (lastPkg > 0) blocks += 1;
                pkgnum += blocks;

                var startpos = 0;
                var endpos = len - startpos;

                for (var i = 1; i <= blocks; i++) {
                    //数据分包
                    if (i == blocks && lastPkg > 0) {
                        len = lastPkg;
                    }
                    //console.log("data size:" + arr.size + " spos:" + startpos + " epos:" + endpos);
                    var slice_data = arr.slice(startpos, endpos);
                    //console.log("send data num:" + i + " slen:" + slice_data.size);
                    ws.send(slice_data);
                    startpos += len;
                    endpos += len;
//                  console.log(slice_data)
//            console.log(pkgnum);
                    //console.log(startpos, endpos)
                }

                var endPkg = "{\"pkgnum\":" + pkgnum + "}";
                ws.send(endPkg);//发最后一个包


            };
            // 接收服务端数据时触发事件
            ws.onmessage = function (evt) {
                var received_msg = JSON.parse(evt.data);
                //console.log("数据已接收...");
                if(received_msg.end_flag == 1){
                    //console.log(received_msg.result.nbest[0]);
                    // console.log(received_msg.result.nbest[0]);
                    _this.itemry = received_msg.result.nbest[0];
                    _this.test();
                } else if (received_msg.errno) {
                    // console.log('error')
                    _this.mediaLoading = false;
                }
            };

            //断开 web socket 连接成功触发事件
            ws.onclose = function () {
                //console.log("连接已关闭...");
            };

        },
      async getUserId() {//获取用户id skillId
        let res = await getUserId()
        this.dev_id = res.data.data.id
        this.quitSkill()
      },
      async quitSkill () {//进入页面，先退出一次技能
        let params = {
          "query":'关闭',
          "skill_id": this.$route.query.skill_id,
          'online': 5,
          "deviceid": "open_"+this.dev_id,
          "nlu_extend": {"speaker_ask_status": 0}
        }
        let res = await postTest(params)
      },
      async test() {
        if (this.flag) return
        this.flag = true
        let params = {
          "query": this.itemry,
          "skill_id": this.$route.query.skill_id,
          'online': 5,
          "deviceid": "open_"+this.dev_id,
          "nlu_extend": {"speaker_ask_status": 0}
        }
        if (this.itemry == '') {
          this.$message.error('输入语句不能为空')
          this.flag = false
          return
        }
        this.$store.dispatch('changedevId',params);
        this.queries.push({name:'user',text:this.itemry});//用户说的话
        this.itemry = ''
        let res = await postTest(params)
        if (res.data.code == 200) {
          this.flag = false
//          this.queries.push({name:'user',text:this.itemry});//用户说的话
//          this.itemry = ''
          let response = []
          if (res.data.data.res) {
            response = res.data.data.res.length == 0 ? [] : JSON.parse(res.data.data.res)
          } else {
            this.flag = false
            response = []
          }
          if (response == []) {
            this.queries.push('')
          } else {
            let result = res.data.data.res.length == 0 ? [] : JSON.parse(res.data.data.res)
            if (result['answer']) {
              if (result.answer.text) {
                let res = await ttsApi(qs.stringify({text: result.answer.text}))
                  this.queries.push({name:'sys',text:result.answer.text})//系统回的话
                if (res.data.code == 200) {
                    this.resources_url = '' // 清空正在播放的音乐资源
                  this.audio_url = res.data.data.resource_url
                    let _this = this
                    document.getElementById('audio').addEventListener('ended', function() { // tts播报完成后 调用音频资源播放
                        // console.log(result.data.playerItemInfo.url)
                        _this.resources_url = result.answer.audio || ''
                    })
                }
              }

              setTimeout(function () {
                let ele = $('#chat');
                let ele_li = $('#chat li');
                ele.animate({scrollTop:ele_li.height() * ele_li.length},500)
                // console.log(ele_li.height() * ele_li.length)
              },0)//滚动至最下方
            } else {
              this.queries.push('')
            }
          }
        } else {
          this.queries.push(this.itemry)
          this.itemry = ''
          this.queries.push('')
          this.flag = false
          this.$message.error('请求失败')
        }
      },
      async getSkillDetail() {//获取技能详情
        let obj = {
          'skill_id': this.$route.query.skill_id,
          'client_id': this.$route.query.client_id,
          'online': 5
        }
        let res = await skillDetailApi(qs.stringify(obj))
        if (res.data.code == 200) {
//          console.log(res.data.data)
          this.skillInfo = res.data.data.data
          if (this.skillInfo.skill_order_word == '') {
            this.skillInfo.skill_order_word = []
          } else {
            this.skillInfo.skill_order_word = JSON.parse(this.skillInfo.skill_order_word)
          }

//          this.skillInfo.chinese_name = res.data.data.data.skill_name
//          this.skillInfo.domain = res.data.data.data.skill_domain
//          this.skillInfo.category = res.data.data.data.nlu_cate_name.split(',')
//          this.skillInfo.dev_id = this.dev_id
//          console.log(this.skillInfo);
        } else {
          this.$message({message: '获取信息失败', type: 'error'})
        }
        // 获取到基本信息
      },
      async invokeSkill(item) {
        let res = await invokeSkillApi(qs.stringify({
          'client_id': this.$route.query.client_id,
          'skill_id': item.skill_id
        }))
        if (res.data.code == 200) {
          this.$message.success('添加成功')
          item.invoke_status = 1
        } else {
          this.$message.error('添加失败')
        }
      },
      async invokeSkillDelete(item) {
        let res = await invokeSkillDeleteApi(qs.stringify({
          'client_id': this.$route.query.client_id,
          'skill_id': item.skill_id
        }))
        if (res.data.code == 200) {
          this.$message.success('取消添加成功')
          item.invoke_status = 0
        } else {
          this.$message.error('取消添加失败')
        }
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss">
  .skillInfo-box {
    background-color: #fff;
    img {
      width: 100%;
      height: 100%;
    }
    @mixin block {
      display: inline-block;
      vertical-align: middle;
    }
    .skill_info_top {
      height: 65px;
      line-height: 65px;
      padding-left: 3%;
      border-left: 2px solid #000;
      border-bottom: 1px solid rgb(247, 248, 247);
      color: rgb(39, 78, 105);
      font-size: 16px;
    }
    .skill_info_bottom {
      .skill_info_left {
        width: 43%;
        margin-top: 30px;
        padding: 0 0 0 30px;
        @include block;
        vertical-align: top;
        .item-content-top {
          position: relative;
          // border: 1px solid #000;
          text-align: left;
          .top-part {
            @include block;
            &:nth-child(1) {
              width: 70px;
              height: 70px;
              border-radius: 10px;
              overflow: hidden;
            }
            &:nth-child(2) {
              margin-left: 27px;
              font-size: 15px;
            }
            vertical-align: top;
            .detailTitle{
              width: 142px;
              line-height: 22px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;

              .blurIcon{
                color: #7abaf1;
              }
            }
          }
          .use_btn {

          }
        }
        .item-content-bottom {
          h4{
            font-size: 16px;
            font-weight: 600;
          }
          .context {
            margin-top: 30px;
            font-size: 14px;
            &:nth-child(1) {
              p {
                @include block;
                &:nth-child(2) {
                  margin-left: 30px;
                }
              }
            }
            &:nth-child(2) {
              margin-top: 10px;
              word-break: break-all;
            }
            &:nth-child(3) {
              p {
                word-break: break-all;
              }
            }
          &:nth-child(4) {
            h3 {
              margin-bottom: 30px;
            }
            p {
              word-break: break-all;
            }
          }
          }
        }
      }
      .skill_info_right {
        @include block;
        position: relative;
        margin-top: 30px;
        margin-left: 35px;
        width: 48%;
        min-width:500px;
        height: 100%;
        min-height: 430px;
        border-radius: 20px;
        padding-bottom: 20px;
        background-color: #f9f9f9;
        #chat {
          padding: 20px 30px 20px 10px;
          width: 100%;
          min-width:500px;
          height: 390px;
          overflow-y: auto;
          img {
            width: 36px;
            height: 36px;
            border-radius: 18px;
            vertical-align: middle;
          }
          li {
            display: flex;
            width: 95%;
            line-height: 25px;
            position: relative;
            p {
              color: #fff;
              padding:8px 10px;
              border-radius: 6px;
              word-break:break-all;
              word-wrap:break-word;
            }
            &#user_speak {
              justify-content: flex-end;
              clear: both;
              padding-right: 10px;
              img {
                margin-left: 20px;
                position: absolute;
                right: -40px;
                top: 0;
              }
              p {
                background: #00a2ef;
                & {
                  max-width: 80%;
                }
                i {
                  width: 0;
                  height: 0;
                  display: inline-block;
                  border-top: 6px solid transparent;
                  border-right: 6px solid transparent;
                  border-left: 6px solid #00a2ef;
                  border-bottom: 6px solid transparent;
                  position: absolute;
                  right: 0;
                  top: 10px;
                }

              }
            }
            &#system_speak {
              img {
                margin-right: 20px;
              }
              p {
                background: #eee;
                color: #333;
                position: relative;
                i {
                  width: 0;
                  height: 0;
                  display: inline-block;
                  border-top: 6px solid transparent;
                  border-right: 6px solid #eee;
                  border-left: 6px solid transparent;
                  border-bottom: 6px solid transparent;
                  position: absolute;
                  left: -10px;
                  top: 10px;
                }
              }
            }
          }

        }
        .voice {
          /*margin-left:10%;*/
          width: 100%;
          min-width:500px;
          text-align: center;
          span {
            position: relative;
            display: inline-block;
            height: 44px;
          }
          input {
            width: 437px;
            height: 44px;
            border-radius: 22px;
            border: 1px solid #00a2ef;
            padding-left: 10px;
            outline: none;
          }
          button {
            width: 93px;
            height: 44px;
            line-height: 22px;
            color: #fff;
            background: #00a2ef;
            border-radius: 22px;
            outline: none;
            position: absolute;
            right: 0;
            top: 0;
          }
          .Microphone{
            width:44px;
            height:44px;
            margin-left:20px;
            vertical-align:middle
          }
        }
      }
    }
    .skill_info_top {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-size: 18px;
      font-weight: 900;
      color: #2e4d79;
      border-bottom: 1px solid #f5f5f5;
      border-left: 2px solid #010202;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/hardware/pro/SkillInfo.vue